import { UserAction } from "../../actions";
import { initialState } from "../..";
// import { toastify } from "../../../utils/tyostify";
import { INotification, INotificationsGroup, IUpdateNotificationsGroupData } from "../../types";
import { reducer } from "../index";

reducer.createHandler<Array<INotification | INotificationsGroup>>(
  UserAction.GetNotificationsSuccess,
  (state, { payload }) => ({
    ...state,
    userModule: {
      ...state.userModule,
      notifications: {
        ...state.userModule.notifications,
        list: [...state.userModule.notifications.list, ...payload],
        page: state.userModule.notifications.page + 1,
        loading: false,
        hasMore: payload.length ? true : false
      }
    }
  })
);

reducer.createHandler<{ id: number; status: string }>(UserAction.UpdateNotificationSuccess, (state, { payload }) => {
  const { id, status } = payload;
  return {
    ...state,
    userModule: {
      ...state.userModule,
      notifications: {
        ...state.userModule.notifications,
        list: state.userModule.notifications.list.map(
          (notification: INotification | INotificationsGroup): INotification | INotificationsGroup => {
            if ((notification as INotification).id === id) {
              return {
                ...notification,
                read_at: status === "read" ? "read" : null
              };
            }

            return notification;
          }
        )
      }
    }
  };
});

reducer.createHandler<number>(UserAction.DeleteNotificationSuccess, (state, { payload }) => ({
  ...state,
  userModule: {
    ...state.userModule,
    notifications: {
      ...state.userModule.notifications,
      list: state.userModule.notifications.list.filter(
        (item: INotification | INotificationsGroup) => (item as INotification).id !== payload
      )
    }
  }
}));

reducer.createHandler<INotification>(UserAction.CreateNotificationSocket, (state, { payload }) => {
  if (state.userModule.notifications.filterByDeal) {
    if (state.dealModule.deal.id === payload.components.deal_id) {
      // toastify(payload.text);
      return {
        ...state,
        userModule: {
          ...state.userModule,
          notifications: {
            ...state.userModule.notifications,
            list: [payload, ...state.userModule.notifications.list]
          }
        }
      };
    } else {
      return state;
    }
  } else {
    // toastify(payload.text);
    return {
      ...state,
      userModule: {
        ...state.userModule,
        notifications: {
          ...state.userModule.notifications,
          list: [payload, ...state.userModule.notifications.list]
        }
      }
    };
  }
});

reducer.createHandler<{ elementIndex: number; status: "read" | "unread" }>(
  UserAction.UpdateNotificationsGroupSuccess,
  (state, { payload }) => ({
    ...state,
    userModule: {
      ...state.userModule,
      notifications: {
        ...state.userModule.notifications,
        list: state.userModule.notifications.list.map((item: INotification | INotificationsGroup, index: number) => {
          if (payload.elementIndex === index) {
            return {
              ...item,
              status: payload.status,
              notifications: (item as INotificationsGroup).notifications.map((item: INotification) => {
                return {
                  ...item,
                  read_at: payload.status === "read" ? "read" : null
                };
              })
            };
          }

          return item;
        })
      }
    }
  })
);

reducer.createHandler<IUpdateNotificationsGroupData>(
  UserAction.UpdateAllNotificationsGroupSuccess,
  (state, { payload }) => {
    const { status } = payload;

    return {
      ...state,
      userModule: {
        ...state.userModule,
        notifications: {
          ...state.userModule.notifications,
          list: state.userModule.notifications.list.map((notification: INotification | INotificationsGroup) => {
            return {
              ...notification,
              status: status,
              read_at: status === "read" ? "read" : null
            };
          })
        }
      }
    };
  }
);

// number - elementIndex
reducer.createHandler<number>(UserAction.DeleteNotificationsGroupSuccess, (state, { payload }) => ({
  ...state,
  userModule: {
    ...state.userModule,
    notifications: {
      ...state.userModule.notifications,
      list: state.userModule.notifications.list.filter((_, index: number) => index !== payload)
    }
  }
}));

reducer.createHandler<number>(UserAction.ReceiveUnreadNotifications, (state, { payload }) => ({
  ...state,
  userModule: {
    ...state.userModule,
    notifications: {
      ...state.userModule.notifications,
      unreadItems: payload
    }
  }
}));

reducer.createHandler<boolean>(UserAction.SetFilterByDeal, (store, { payload }) => ({
  ...store,
  userModule: {
    ...store.userModule,
    notifications: {
      ...initialState.userModule.notifications,
      filterByDeal: payload
    }
  }
}));
